/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Box, Button } from '@radix-ui/themes';

import { styled } from 'fierry/react';

import Swatch from 'solis/claude/element/user/swatch';


const Container = styled(Button)`
  justify-content: flex-start;
  gap: var(--space-2);
`;


const Component = ({ count, onExpand }) =>
(
  <Container variant = 'ghost' color = 'gray' size = '1' onClick = {onExpand}>

    <Box width = '40px' />
    <Swatch />

    {count} more

  </Container>
);


export default ({ count, onExpand }) =>
{
  return count > 0 ? <Component count = {count} onExpand = {onExpand} /> : null;
};
